import { render, staticRenderFns } from "./SupportHub.vue?vue&type=template&id=1f52415e&"
import script from "./SupportHub.vue?vue&type=script&lang=js&"
export * from "./SupportHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports